var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 3.96844H5.96719V9.25438C5.96719 9.32313 6.02344 9.37938 6.09219 9.37938H7.02969C7.09844 9.37938 7.15469 9.32313 7.15469 9.25438V3.96844H8.3125C8.41719 3.96844 8.475 3.84813 8.41094 3.76688L6.66094 1.55126C6.64924 1.53632 6.6343 1.52423 6.61725 1.51592C6.60019 1.50761 6.58147 1.5033 6.5625 1.5033C6.54353 1.5033 6.52481 1.50761 6.50775 1.51592C6.49069 1.52423 6.47576 1.53632 6.46406 1.55126L4.71406 3.76532C4.65 3.84813 4.70781 3.96844 4.8125 3.96844ZM12.2812 8.78563H11.3438C11.275 8.78563 11.2188 8.84188 11.2188 8.91063V11.3169H1.90625V8.91063C1.90625 8.84188 1.85 8.78563 1.78125 8.78563H0.84375C0.775 8.78563 0.71875 8.84188 0.71875 8.91063V12.0044C0.71875 12.2809 0.942187 12.5044 1.21875 12.5044H11.9062C12.1828 12.5044 12.4062 12.2809 12.4062 12.0044V8.91063C12.4062 8.84188 12.35 8.78563 12.2812 8.78563Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d4c30ed7.svg";
export { ForwardRef as ReactComponent };